<template>
  <v-tooltip bottom color="grey lighten-1">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs" 
        v-on="on" 
        color="primary"
        dark
        small
        fab
        top
        left
        class="v-btn--home"
        @click="gotoTop"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </template>
    <span>ホームに戻る</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'BackHomeBtn',
  methods:{
    // トップ画面に遷移
    gotoTop() {
      this.$router.push('/').catch(()=>{});
    },
  },
}
</script>

<style scoped>
.v-btn--home {
  z-index: 1;
  top: 80px;
  position: fixed;
  margin: 0 0 16px 16px;
}  
@media screen and (max-width: 959px)  {
  .v-btn--home {
    display: none;
  }  
}
</style>